/**
 * Battle Frontier: the Restricted Sparring opponent roster —
 * GENERATED by client/setup_client.py from data/gen8 (the
 * public 150-set Master Dojo Student roster; one set per
 * species). Consumed by the BF-SPARRING-TOOLTIP patch in
 * battle-tooltips.ts. Do not edit; re-run the setup script.
 */

export const BFSparringSets: { [speciesid: string]: {
	item: string, nature: string, ability: string, evs: string,
	stats: string, moves: string[],
} } = {
 "orbeetle": {
  "item": "Room Service",
  "nature": "Quiet",
  "ability": "Swarm, Frisk or Telepathy (random)",
  "evs": "252 HP / 252 SpA",
  "stats": "159 HP / 57 Atk / 122 Def / 136 SpA / 132 SpD / 91 Spe",
  "moves": [
   "Trick Room",
   "Calm Mind",
   "Psychic",
   "Shadow Ball"
  ]
 },
 "butterfree": {
  "item": "Leftovers",
  "nature": "Timid",
  "ability": "Compound Eyes or Tinted Lens (random)",
  "evs": "252 HP / 252 Spe",
  "stats": "159 HP / 51 Atk / 62 Def / 102 SpA / 92 SpD / 125 Spe",
  "moves": [
   "Sleep Powder",
   "Substitute",
   "Quiver Dance",
   "Hurricane"
  ]
 },
 "corviknight": {
  "item": "Petaya Berry",
  "nature": "Bold",
  "ability": "Pressure, Unnerve or Mirror Armor (random)",
  "evs": "252 Def / 252 SpA",
  "stats": "165 HP / 89 Atk / 163 Def / 97 SpA / 97 SpD / 79 Spe",
  "moves": [
   "Steel Beam",
   "Metal Sound",
   "Taunt",
   "Spite"
  ]
 },
 "greedent": {
  "item": "Petaya Berry",
  "nature": "Modest",
  "ability": "Cheek Pouch or Gluttony (random)",
  "evs": "252 HP / 252 Def",
  "stats": "219 HP / 96 Atk / 139 Def / 73 SpA / 87 SpD / 32 Spe",
  "moves": [
   "Stuff Cheeks",
   "Belch",
   "Thief",
   "Hyper Beam"
  ]
 },
 "thievul": {
  "item": "Red Card",
  "nature": "Modest",
  "ability": "Run Away, Unburden or Stakeout (random)",
  "evs": "252 HP / 252 Spe",
  "stats": "169 HP / 63 Atk / 70 Def / 108 SpA / 104 SpD / 134 Spe",
  "moves": [
   "Torment",
   "Knock Off",
   "Burning Jealousy",
   "Parting Shot"
  ]
 },
 "obstagoon": {
  "item": "Kee Berry",
  "nature": "Jolly",
  "ability": "Reckless, Guts or Defiant (random)",
  "evs": "252 HP / 252 Spe",
  "stats": "192 HP / 102 Atk / 113 Def / 64 SpA / 93 SpD / 152 Spe",
  "moves": [
   "Obstruct",
   "Parting Shot",
   "Lash Out",
   "Counter"
  ]
 },
 "dubwool": {
  "item": "Luminous Moss",
  "nature": "Bold",
  "ability": "Fluffy, Steadfast or Bulletproof (random)",
  "evs": "252 HP / 252 Def",
  "stats": "171 HP / 82 Atk / 158 Def / 72 SpA / 102 SpD / 100 Spe",
  "moves": [
   "Cotton Guard",
   "Copycat",
   "Last Resort",
   "Reversal"
  ]
 },
 "drednaw": {
  "item": "Expert Belt",
  "nature": "Adamant",
  "ability": "Strong Jaw, Shell Armor or Swift Swim (random)",
  "evs": "252 HP / 252 Atk",
  "stats": "189 HP / 174 Atk / 102 Def / 54 SpA / 80 SpD / 86 Spe",
  "moves": [
   "Skitter Smack",
   "Jaw Lock",
   "Skull Bash",
   "Dragon Tail"
  ]
 },
 "boltund": {
  "item": "Cell Battery",
  "nature": "Jolly",
  "ability": "Strong Jaw or Competitive (random)",
  "evs": "252 Atk / 252 Spe",
  "stats": "136 HP / 134 Atk / 72 Def / 91 SpA / 72 SpD / 181 Spe",
  "moves": [
   "Electrify",
   "Wild Charge",
   "Fire Fang",
   "Crunch"
  ]
 },
 "cinccino": {
  "item": "Metronome",
  "nature": "Jolly",
  "ability": "Cute Charm, Technician or Skill Link (random)",
  "evs": "252 Atk / 252 Spe",
  "stats": "142 HP / 139 Atk / 72 Def / 69 SpA / 72 SpD / 174 Spe",
  "moves": [
   "Bullet Seed",
   "Rock Blast",
   "Tail Slap",
   "Triple Axel"
  ]
 },
 "vileplume": {
  "item": "Big Root",
  "nature": "Gentle",
  "ability": "Chlorophyll or Effect Spore (random)",
  "evs": "252 HP / 252 SpD",
  "stats": "174 HP / 92 Atk / 87 Def / 122 SpA / 147 SpD / 62 Spe",
  "moves": [
   "Corrosive Gas",
   "Giga Drain",
   "Moonblast",
   "Strength Sap"
  ]
 },
 "pelipper": {
  "item": "Sharp Beak",
  "nature": "Modest",
  "ability": "Keen Eye, Drizzle or Rain Dish (random)",
  "evs": "252 SpA / 252 Spe",
  "stats": "127 HP / 55 Atk / 112 Def / 152 SpA / 82 SpD / 109 Spe",
  "moves": [
   "Stockpile",
   "Swallow",
   "Spit Up",
   "Hurricane"
  ]
 },
 "galvantula": {
  "item": "Utility Umbrella",
  "nature": "Hardy",
  "ability": "Compound Eyes, Unnerve or Swarm (random)",
  "evs": "252 Atk / 252 SpA",
  "stats": "137 HP / 121 Atk / 72 Def / 141 SpA / 72 SpD / 120 Spe",
  "moves": [
   "Thunder",
   "Sticky Web",
   "Sucker Punch",
   "Bug Bite"
  ]
 },
 "vanilluxe": {
  "item": "Never-Melt Ice",
  "nature": "Hasty",
  "ability": "Ice Body, Snow Warning or Weak Armor (random)",
  "evs": "252 SpA / 252 Spe",
  "stats": "138 HP / 107 Atk / 87 Def / 154 SpA / 107 SpD / 135 Spe",
  "moves": [
   "Acid Armor",
   "Ice Beam",
   "Light Screen",
   "Flash Cannon"
  ]
 },
 "mamoswine": {
  "item": "Wise Glasses",
  "nature": "Timid",
  "ability": "Oblivious, Snow Cloak or Thick Fat (random)",
  "evs": "252 HP / 252 SpA",
  "stats": "209 HP / 127 Atk / 92 Def / 114 SpA / 72 SpD / 101 Spe",
  "moves": [
   "Icy Wind",
   "Amnesia",
   "Ice Beam",
   "Earth Power"
  ]
 },
 "froslass": {
  "item": "Lum Berry",
  "nature": "Jolly",
  "ability": "Snow Cloak or Cursed Body (random)",
  "evs": "252 Atk / 252 Spe",
  "stats": "137 HP / 124 Atk / 82 Def / 82 SpA / 82 SpD / 169 Spe",
  "moves": [
   "Will-O-Wisp",
   "Triple Axel",
   "Poltergeist",
   "Draining Kiss"
  ]
 },
 "crustle": {
  "item": "Smooth Rock",
  "nature": "Impish",
  "ability": "Sturdy, Shell Armor or Weak Armor (random)",
  "evs": "252 HP / 252 Def",
  "stats": "169 HP / 117 Atk / 185 Def / 69 SpA / 87 SpD / 57 Spe",
  "moves": [
   "Heavy Slam",
   "Body Press",
   "Iron Defense",
   "Sandstorm"
  ]
 },
 "golurk": {
  "item": "Life Orb",
  "nature": "Adamant",
  "ability": "Iron Fist, Klutz or No Guard (random)",
  "evs": "252 Atk / 252 SpD",
  "stats": "156 HP / 184 Atk / 92 Def / 60 SpA / 124 SpD / 67 Spe",
  "moves": [
   "Phantom Force",
   "Dynamic Punch",
   "Fly",
   "Dig"
  ]
 },
 "musharna": {
  "item": "Sitrus Berry",
  "nature": "Bold",
  "ability": "Forewarn, Synchronize or Telepathy (random)",
  "evs": "252 HP / 252 SpD",
  "stats": "215 HP / 60 Atk / 106 Def / 119 SpA / 139 SpD / 41 Spe",
  "moves": [
   "Psychic Terrain",
   "Expanding Force",
   "Trick Room",
   "Yawn"
  ]
 },
 "abomasnow": {
  "item": "Miracle Seed",
  "nature": "Adamant",
  "ability": "Snow Warning or Soundproof (random)",
  "evs": "252 HP / 252 Atk",
  "stats": "189 HP / 149 Atk / 87 Def / 93 SpA / 97 SpD / 72 Spe",
  "moves": [
   "Ice Punch",
   "Wood Hammer",
   "Ice Shard",
   "Ingrain"
  ]
 },
 "kingler": {
  "item": "Wacan Berry",
  "nature": "Adamant",
  "ability": "Hyper Cutter, Shell Armor or Sheer Force (random)",
  "evs": "252 Atk / 252 Def",
  "stats": "122 HP / 191 Atk / 159 Def / 55 SpA / 62 SpD / 87 Spe",
  "moves": [
   "High Horsepower",
   "Crabhammer",
   "X-Scissor",
   "Agility"
  ]
 },
 "quagsire": {
  "item": "Leftovers",
  "nature": "Careful",
  "ability": "Damp, Water Absorb or Unaware (random)",
  "evs": "252 HP / 252 SpD",
  "stats": "194 HP / 97 Atk / 97 Def / 69 SpA / 119 SpD / 47 Spe",
  "moves": [
   "Earthquake",
   "Aqua Tail",
   "Power-Up Punch",
   "Yawn"
  ]
 },
 "crawdaunt": {
  "item": "Assault Vest",
  "nature": "Adamant",
  "ability": "Hyper Cutter, Shell Armor or Adaptability (random)",
  "evs": "252 Atk / 252 Def",
  "stats": "130 HP / 180 Atk / 129 Def / 91 SpA / 67 SpD / 67 Spe",
  "moves": [
   "Knock Off",
   "Crabhammer",
   "Brick Break",
   "Rock Tomb"
  ]
 },
 "klinklang": {
  "item": "Lum Berry",
  "nature": "Adamant",
  "ability": "Plus, Minus or Clear Body (random)",
  "evs": "252 HP / 252 Atk",
  "stats": "159 HP / 158 Atk / 127 Def / 73 SpA / 97 SpD / 102 Spe",
  "moves": [
   "Shift Gear",
   "Wild Charge",
   "Gear Grind",
   "Power Gem"
  ]
 },
 "vespiquen": {
  "item": "Red Card",
  "nature": "Hardy",
  "ability": "Pressure or Unnerve (random)",
  "evs": "252 HP / 252 Spe",
  "stats": "169 HP / 92 Atk / 114 Def / 92 SpA / 114 SpD / 84 Spe",
  "moves": [
   "Toxic Spikes",
   "U-turn",
   "Venoshock",
   "Thief"
  ]
 },
 "gardevoir": {
  "item": "Psychic Seed",
  "nature": "Modest",
  "ability": "Synchronize, Trace or Telepathy (random)",
  "evs": "252 HP / 252 SpA",
  "stats": "167 HP / 69 Atk / 77 Def / 185 SpA / 127 SpD / 92 Spe",
  "moves": [
   "Psychic Terrain",
   "Psychic",
   "Mystical Fire",
   "Grudge"
  ]
 },
 "gallade": {
  "item": "Cell Battery",
  "nature": "Adamant",
  "ability": "Steadfast or Justified (random)",
  "evs": "252 Atk / 252 Spe",
  "stats": "135 HP / 185 Atk / 77 Def / 69 SpA / 127 SpD / 124 Spe",
  "moves": [
   "Psycho Cut",
   "Aerial Ace",
   "Swords Dance",
   "Leaf Blade"
  ]
 },
 "drifblim": {
  "item": "Flame Orb",
  "nature": "Calm",
  "ability": "Aftermath, Unburden or Flare Boost (random)",
  "evs": "252 HP / 252 SpA",
  "stats": "249 HP / 82 Atk / 56 Def / 134 SpA / 72 SpD / 92 Spe",
  "moves": [
   "Trick",
   "Tailwind",
   "Hex",
   "Thunderbolt"
  ]
 },
 "eldegoss": {
  "item": "Eject Pack",
  "nature": "Modest",
  "ability": "Cotton Down, Regenerator or Effect Spore (random)",
  "evs": "252 HP / 252 SpD",
  "stats": "159 HP / 55 Atk / 102 Def / 101 SpA / 164 SpD / 72 Spe",
  "moves": [
   "Worry Seed",
   "Hyper Voice",
   "Leaf Storm",
   "Grassy Terrain"
  ]
 },
 "skuntank": {
  "item": "Salac Berry",
  "nature": "Timid",
  "ability": "Stench, Aftermath or Keen Eye (random)",
  "evs": "252 SpA / 252 Spe",
  "stats": "170 HP / 94 Atk / 79 Def / 115 SpA / 73 SpD / 140 Spe",
  "moves": [
   "Burning Jealousy",
   "Corrosive Gas",
   "Memento",
   "Acid Spray"
  ]
 },
 "seismitoad": {
  "item": "Poison Barb",
  "nature": "Lonely",
  "ability": "Swift Swim, Poison Touch or Water Absorb (random)",
  "evs": "252 HP / 252 SpD",
  "stats": "204 HP / 117 Atk / 78 Def / 97 SpA / 119 SpD / 86 Spe",
  "moves": [
   "Gastro Acid",
   "Poison Jab",
   "Surf",
   "Venom Drench"
  ]
 },
 "dusknoir": {
  "item": "Expert Belt",
  "nature": "Adamant",
  "ability": "Pressure or Frisk (random)",
  "evs": "252 HP / 252 Atk",
  "stats": "144 HP / 158 Atk / 147 Def / 69 SpA / 147 SpD / 57 Spe",
  "moves": [
   "Shadow Punch",
   "Fire Punch",
   "Ice Punch",
   "Thunder Punch"
  ]
 },
 "gyarados": {
  "item": "Rocky Helmet",
  "nature": "Bold",
  "ability": "Intimidate or Moxie (random)",
  "evs": "252 HP / 252 Def",
  "stats": "194 HP / 123 Atk / 135 Def / 72 SpA / 112 SpD / 93 Spe",
  "moves": [
   "Scald",
   "Taunt",
   "Whirlpool",
   "Icy Wind"
  ]
 },
 "seaking": {
  "item": "Assault Vest",
  "nature": "Jolly",
  "ability": "Swift Swim, Water Veil or Lightning Rod (random)",
  "evs": "252 Atk / 252 Spe",
  "stats": "147 HP / 136 Atk / 77 Def / 69 SpA / 92 SpD / 123 Spe",
  "moves": [
   "Flip Turn",
   "Waterfall",
   "Drill Run",
   "Bounce"
  ]
 },
 "octillery": {
  "item": "Starf Berry",
  "nature": "Quiet",
  "ability": "Suction Cups, Sniper or Moody (random)",
  "evs": "252 Atk / 252 SpA",
  "stats": "142 HP / 149 Atk / 87 Def / 163 SpA / 87 SpD / 51 Spe",
  "moves": [
   "Octazooka",
   "Gunk Shot",
   "Rock Blast",
   "Endure"
  ]
 },
 "cloyster": {
  "item": "Shell Bell",
  "nature": "Adamant",
  "ability": "Shell Armor, Skill Link or Overcoat (random)",
  "evs": "252 Atk / 252 Spe",
  "stats": "117 HP / 152 Atk / 192 Def / 87 SpA / 57 SpD / 114 Spe",
  "moves": [
   "Shell Smash",
   "Icicle Spear",
   "Rock Blast",
   "Razor Shell"
  ]
 },
 "milotic": {
  "item": "Leftovers",
  "nature": "Hardy",
  "ability": "Marvel Scale, Competitive or Cute Charm (random)",
  "evs": "252 HP / 252 SpD",
  "stats": "194 HP / 72 Atk / 91 Def / 112 SpA / 169 SpD / 93 Spe",
  "moves": [
   "Ice Beam",
   "Scald",
   "Rest",
   "Sleep Talk"
  ]
 },
 "wishiwashi": {
  "item": "Figy Berry",
  "nature": "Quiet",
  "ability": "Schooling",
  "evs": "252 HP / 252 SpA",
  "stats": "144 HP / 32 Atk / 32 Def / 75 SpA / 37 SpD / 46 Spe",
  "moves": [
   "Ice Beam",
   "Aqua Ring",
   "Earthquake",
   "Brine"
  ]
 },
 "pyukumuku": {
  "item": "Red Card",
  "nature": "Sassy",
  "ability": "Innards Out or Unaware (random)",
  "evs": "252 Def / 252 SpD",
  "stats": "122 HP / 72 Atk / 174 Def / 42 SpA / 191 SpD / 15 Spe",
  "moves": [
   "Spite",
   "Toxic",
   "Mirror Coat",
   "Counter"
  ]
 },
 "garbodor": {
  "item": "Blunder Policy",
  "nature": "Adamant",
  "ability": "Stench, Weak Armor or Aftermath (random)",
  "evs": "252 Atk / 252 Def",
  "stats": "147 HP / 152 Atk / 126 Def / 64 SpA / 94 SpD / 87 Spe",
  "moves": [
   "Gunk Shot",
   "Body Slam",
   "Seed Bomb",
   "Stomping Tantrum"
  ]
 },
 "centiskorch": {
  "item": "Leftovers",
  "nature": "Hardy",
  "ability": "Flash Fire, White Smoke or Flame Body (random)",
  "evs": "252 HP / 252 SpD",
  "stats": "199 HP / 127 Atk / 77 Def / 102 SpA / 134 SpD / 77 Spe",
  "moves": [
   "Scorching Sands",
   "Burn Up",
   "Skitter Smack",
   "Lunge"
  ]
 },
 "coalossal": {
  "item": "Liechi Berry",
  "nature": "Adamant",
  "ability": "Steam Engine, Flame Body or Flash Fire (random)",
  "evs": "252 HP / 252 Atk",
  "stats": "209 HP / 136 Atk / 132 Def / 82 SpA / 102 SpD / 42 Spe",
  "moves": [
   "Tar Shot",
   "Heat Crash",
   "Endure",
   "Rock Blast"
  ]
 },
 "gigalith": {
  "item": "Power Herb",
  "nature": "Modest",
  "ability": "Sturdy, Sand Stream or Sand Force (random)",
  "evs": "252 SpA / 252 SpD",
  "stats": "152 HP / 132 Atk / 142 Def / 114 SpA / 124 SpD / 37 Spe",
  "moves": [
   "Meteor Beam",
   "Weather Ball",
   "Flash Cannon",
   "Body Press"
  ]
 },
 "conkeldurr": {
  "item": "Life Orb",
  "nature": "Impish",
  "ability": "Guts, Sheer Force or Iron Fist (random)",
  "evs": "252 HP / 252 Def",
  "stats": "204 HP / 152 Atk / 152 Def / 60 SpA / 77 SpD / 57 Spe",
  "moves": [
   "Low Kick",
   "Bulk Up",
   "Focus Punch",
   "Stone Edge"
  ]
 },
 "swoobat": {
  "item": "Mental Herb",
  "nature": "Timid",
  "ability": "Unaware, Klutz or Simple (random)",
  "evs": "252 HP / 252 Spe",
  "stats": "166 HP / 62 Atk / 67 Def / 89 SpA / 67 SpD / 173 Spe",
  "moves": [
   "Future Sight",
   "U-turn",
   "Skill Swap",
   "Light Screen"
  ]
 },
 "steelix": {
  "item": "Ganlon Berry",
  "nature": "Impish",
  "ability": "Rock Head, Sturdy or Sheer Force (random)",
  "evs": "252 Atk / 252 Def",
  "stats": "142 HP / 129 Atk / 268 Def / 60 SpA / 77 SpD / 42 Spe",
  "moves": [
   "Dig",
   "Steel Roller",
   "Heavy Slam",
   "Body Press"
  ]
 },
 "barraskewda": {
  "item": "Rindo Berry",
  "nature": "Jolly",
  "ability": "Swift Swim or Propeller Tail (random)",
  "evs": "252 Atk / 252 Spe",
  "stats": "128 HP / 167 Atk / 72 Def / 64 SpA / 62 SpD / 198 Spe",
  "moves": [
   "Acupressure",
   "Waterfall",
   "Ice Fang",
   "Drill Run"
  ]
 },
 "perrserker": {
  "item": "Metal Coat",
  "nature": "Adamant",
  "ability": "Battle Armor, Tough Claws or Steely Spirit (random)",
  "evs": "252 HP / 252 Atk",
  "stats": "169 HP / 169 Atk / 112 Def / 55 SpA / 72 SpD / 62 Spe",
  "moves": [
   "Iron Head",
   "Screech",
   "Fake Out",
   "Close Combat"
  ]
 },
 "alcremie": {
  "item": "Misty Seed",
  "nature": "Calm",
  "ability": "Sweet Veil or Aroma Veil (random)",
  "evs": "252 HP / 252 SpD",
  "stats": "164 HP / 64 Atk / 87 Def / 122 SpA / 181 SpD / 76 Spe",
  "moves": [
   "Baby-Doll Eyes",
   "Misty Explosion",
   "Safeguard",
   "Fake Tears"
  ]
 },
 "ribombee": {
  "item": "Pixie Plate",
  "nature": "Timid",
  "ability": "Honey Gather, Shield Dust or Sweet Veil (random)",
  "evs": "252 SpA / 252 Spe",
  "stats": "127 HP / 60 Atk / 72 Def / 139 SpA / 82 SpD / 184 Spe",
  "moves": [
   "Pollen Puff",
   "Moonblast",
   "Psychic",
   "Bug Buzz"
  ]
 },
 "gourgeist": {
  "item": "Spell Tag",
  "nature": "Hardy",
  "ability": "Pickup, Frisk or Insomnia (random)",
  "evs": "252 HP / 252 Atk",
  "stats": "164 HP / 134 Atk / 134 Def / 70 SpA / 87 SpD / 96 Spe",
  "moves": [
   "Trick-or-Treat",
   "Shadow Sneak",
   "Phantom Force",
   "Disable"
  ]
 },
 "slurpuff": {
  "item": "Misty Seed",
  "nature": "Bold",
  "ability": "Sweet Veil or Unburden (random)",
  "evs": "252 HP / 252 Def",
  "stats": "181 HP / 82 Atk / 143 Def / 97 SpA / 87 SpD / 84 Spe",
  "moves": [
   "Cotton Guard",
   "Misty Explosion",
   "Wish",
   "Sticky Web"
  ]
 },
 "aromatisse": {
  "item": "Pixie Plate",
  "nature": "Calm",
  "ability": "Healer or Aroma Veil (random)",
  "evs": "252 HP / 252 SpD",
  "stats": "200 HP / 75 Atk / 84 Def / 111 SpA / 146 SpD / 41 Spe",
  "moves": [
   "Moonblast",
   "Wish",
   "Calm Mind",
   "Draining Kiss"
  ]
 },
 "sirfetchd": {
  "item": "Leek",
  "nature": "Brave",
  "ability": "Steadfast or Scrappy (random)",
  "evs": "252 Atk / 252 Def",
  "stats": "129 HP / 196 Atk / 139 Def / 80 SpA / 94 SpD / 69 Spe",
  "moves": [
   "Grassy Glide",
   "Meteor Assault",
   "Brave Bird",
   "Defog"
  ]
 },
 "lanturn": {
  "item": "Leftovers",
  "nature": "Modest",
  "ability": "Volt Absorb, Illuminate or Water Absorb (random)",
  "evs": "252 HP / 252 SpA",
  "stats": "224 HP / 63 Atk / 70 Def / 132 SpA / 88 SpD / 79 Spe",
  "moves": [
   "Stockpile",
   "Aqua Ring",
   "Surf",
   "Thunderbolt"
  ]
 },
 "toxicroak": {
  "item": "Payapa Berry",
  "nature": "Modest",
  "ability": "Anticipation, Dry Skin or Poison Touch (random)",
  "evs": "252 Atk / 252 Spe",
  "stats": "150 HP / 135 Atk / 77 Def / 107 SpA / 77 SpD / 129 Spe",
  "moves": [
   "Corrosive Gas",
   "Sludge Wave",
   "Nasty Plot",
   "Shadow Ball"
  ]
 },
 "scrafty": {
  "item": "Life Orb",
  "nature": "Adamant",
  "ability": "Shed Skin, Moxie or Intimidate (random)",
  "evs": "252 HP / 252 Atk",
  "stats": "164 HP / 147 Atk / 127 Def / 51 SpA / 127 SpD / 70 Spe",
  "moves": [
   "Low Kick",
   "Drain Punch",
   "Facade",
   "Swagger"
  ]
 },
 "whiscash": {
  "item": "Adrenaline Orb",
  "nature": "Jolly",
  "ability": "Oblivious, Anticipation or Hydration (random)",
  "evs": "252 Atk / 252 Spe",
  "stats": "177 HP / 122 Atk / 85 Def / 79 SpA / 83 SpD / 114 Spe",
  "moves": [
   "Dragon Dance",
   "Waterfall",
   "Zen Headbutt",
   "Earthquake"
  ]
 },
 "golisopod": {
  "item": "Leftovers",
  "nature": "Impish",
  "ability": "Emergency Exit",
  "evs": "252 Atk / 252 Def",
  "stats": "142 HP / 169 Atk / 202 Def / 64 SpA / 102 SpD / 52 Spe",
  "moves": [
   "First Impression",
   "Razor Shell",
   "Skitter Smack",
   "Close Combat"
  ]
 },
 "cursola": {
  "item": "Ring Target",
  "nature": "Calm",
  "ability": "Weak Armor or Perish Body (random)",
  "evs": "252 HP / 252 Def",
  "stats": "159 HP / 96 Atk / 94 Def / 157 SpA / 156 SpD / 42 Spe",
  "moves": [
   "Spite",
   "Shadow Ball",
   "Grudge",
   "Endure"
  ]
 },
 "salazzle": {
  "item": "Dragon Fang",
  "nature": "Jolly",
  "ability": "Corrosion or Oblivious (random)",
  "evs": "252 HP / 252 Spe",
  "stats": "167 HP / 76 Atk / 72 Def / 110 SpA / 72 SpD / 177 Spe",
  "moves": [
   "Scale Shot",
   "Corrosive Gas",
   "Acrobatics",
   "Disable"
  ]
 },
 "bisharp": {
  "item": "Black Glasses",
  "nature": "Adamant",
  "ability": "Defiant, Inner Focus or Pressure (random)",
  "evs": "252 HP / 252 Atk",
  "stats": "164 HP / 185 Atk / 112 Def / 64 SpA / 82 SpD / 82 Spe",
  "moves": [
   "Sucker Punch",
   "Torment",
   "Brick Break",
   "Slash"
  ]
 },
 "rhyperior": {
  "item": "Weakness Policy",
  "nature": "Brave",
  "ability": "Lightning Rod, Solid Rock or Reckless (random)",
  "evs": "252 Atk / 252 Def",
  "stats": "182 HP / 202 Atk / 174 Def / 67 SpA / 67 SpD / 46 Spe",
  "moves": [
   "Rock Wrecker",
   "Heat Crash",
   "Sandstorm",
   "Breaking Swipe"
  ]
 },
 "escavalier": {
  "item": "Occa Berry",
  "nature": "Brave",
  "ability": "Swarm, Shell Armor or Overcoat (random)",
  "evs": "252 HP / 252 Atk",
  "stats": "169 HP / 196 Atk / 117 Def / 72 SpA / 117 SpD / 28 Spe",
  "moves": [
   "Screech",
   "Smart Strike",
   "Razor Shell",
   "Metal Burst"
  ]
 },
 "accelgor": {
  "item": "Wiki Berry",
  "nature": "Timid",
  "ability": "Hydration, Sticky Hold or Unburden (random)",
  "evs": "252 SpA / 252 Spe",
  "stats": "147 HP / 73 Atk / 52 Def / 144 SpA / 72 SpD / 207 Spe",
  "moves": [
   "Acid Spray",
   "Leech Life",
   "Sludge Bomb",
   "Spikes"
  ]
 },
 "beheeyem": {
  "item": "Psychic Seed",
  "nature": "Quiet",
  "ability": "Telepathy, Synchronize or Analytic (random)",
  "evs": "252 HP / 252 SpA",
  "stats": "174 HP / 87 Atk / 87 Def / 185 SpA / 107 SpD / 46 Spe",
  "moves": [
   "Psychic Terrain",
   "Psychic",
   "Cosmic Power",
   "Energy Ball"
  ]
 },
 "beartic": {
  "item": "Damp Rock",
  "nature": "Adamant",
  "ability": "Snow Cloak, Slush Rush or Swift Swim (random)",
  "evs": "252 Atk / 252 Spe",
  "stats": "162 HP / 191 Atk / 92 Def / 73 SpA / 92 SpD / 94 Spe",
  "moves": [
   "Rain Dance",
   "Liquidation",
   "Superpower",
   "Swords Dance"
  ]
 },
 "braviary": {
  "item": "Adrenaline Orb",
  "nature": "Jolly",
  "ability": "Keen Eye, Sheer Force or Defiant (random)",
  "evs": "252 Atk / 252 Spe",
  "stats": "167 HP / 167 Atk / 87 Def / 62 SpA / 87 SpD / 136 Spe",
  "moves": [
   "Brave Bird",
   "Whirlwind",
   "Iron Head",
   "Bulk Up"
  ]
 },
 "mandibuzz": {
  "item": "Sticky Barb",
  "nature": "Timid",
  "ability": "Big Pecks, Overcoat or Weak Armor (random)",
  "evs": "252 HP / 252 Spe",
  "stats": "209 HP / 69 Atk / 117 Def / 67 SpA / 107 SpD / 136 Spe",
  "moves": [
   "Snarl",
   "Tailwind",
   "Knock Off",
   "Bone Rush"
  ]
 },
 "drapion": {
  "item": "Chilan Berry",
  "nature": "Jolly",
  "ability": "Battle Armor, Sniper or Keen Eye (random)",
  "evs": "252 HP / 252 Spe",
  "stats": "169 HP / 102 Atk / 122 Def / 64 SpA / 87 SpD / 152 Spe",
  "moves": [
   "Acupressure",
   "Poison Fang",
   "Skitter Smack",
   "Crunch"
  ]
 },
 "malamar": {
  "item": "Quick Claw",
  "nature": "Brave",
  "ability": "Contrary, Suction Cups or Infiltrator (random)",
  "evs": "252 HP / 252 Atk",
  "stats": "185 HP / 149 Atk / 100 Def / 80 SpA / 87 SpD / 76 Spe",
  "moves": [
   "Superpower",
   "Baton Pass",
   "Liquidation",
   "Night Slash"
  ]
 },
 "weavile": {
  "item": "Scope Lens",
  "nature": "Jolly",
  "ability": "Pressure or Pickpocket (random)",
  "evs": "252 Atk / 252 Spe",
  "stats": "137 HP / 164 Atk / 77 Def / 51 SpA / 97 SpD / 185 Spe",
  "moves": [
   "Triple Axel",
   "Night Slash",
   "Shadow Claw",
   "Taunt"
  ]
 },
 "torkoal": {
  "item": "Charcoal",
  "nature": "Quiet",
  "ability": "White Smoke, Drought or Shell Armor (random)",
  "evs": "252 HP / 252 SpA",
  "stats": "169 HP / 97 Atk / 152 Def / 141 SpA / 82 SpD / 28 Spe",
  "moves": [
   "Lava Plume",
   "Scorching Sands",
   "Amnesia",
   "Solar Beam"
  ]
 },
 "jellicent": {
  "item": "Spell Tag",
  "nature": "Calm",
  "ability": "Water Absorb, Cursed Body or Damp (random)",
  "evs": "252 HP / 252 SpD",
  "stats": "199 HP / 64 Atk / 82 Def / 97 SpA / 163 SpD / 72 Spe",
  "moves": [
   "Poltergeist",
   "Brine",
   "Substitute",
   "Sludge Wave"
  ]
 },
 "toxapex": {
  "item": "Rocky Helmet",
  "nature": "Bold",
  "ability": "Merciless, Limber or Regenerator (random)",
  "evs": "252 HP / 252 Def",
  "stats": "149 HP / 67 Atk / 215 Def / 65 SpA / 154 SpD / 47 Spe",
  "moves": [
   "Baneful Bunker",
   "Venoshock",
   "Venom Drench",
   "Surf"
  ]
 },
 "cramorant": {
  "item": "Leftovers",
  "nature": "Calm",
  "ability": "Gulp Missile",
  "evs": "252 HP / 252 SpD",
  "stats": "169 HP / 87 Atk / 67 Def / 97 SpA / 152 SpD / 97 Spe",
  "moves": [
   "Surf",
   "Aqua Ring",
   "Endure",
   "Feather Dance"
  ]
 },
 "sandaconda": {
  "item": "Quick Claw",
  "nature": "Relaxed",
  "ability": "Sand Spit, Shed Skin or Sand Veil (random)",
  "evs": "252 HP / 252 Def",
  "stats": "171 HP / 119 Atk / 185 Def / 77 SpA / 82 SpD / 74 Spe",
  "moves": [
   "Scorching Sands",
   "Skitter Smack",
   "Coil",
   "Sand Tomb"
  ]
 },
 "runerigus": {
  "item": "Sticky Barb",
  "nature": "Gentle",
  "ability": "Wandering Spirit",
  "evs": "252 HP / 252 SpA",
  "stats": "157 HP / 107 Atk / 141 Def / 94 SpA / 128 SpD / 42 Spe",
  "moves": [
   "Haze",
   "Night Shade",
   "Dark Pulse",
   "Earth Power"
  ]
 },
 "trevenant": {
  "item": "Assault Vest",
  "nature": "Adamant",
  "ability": "Natural Cure, Frisk or Harvest (random)",
  "evs": "252 HP / 252 Atk",
  "stats": "184 HP / 169 Atk / 88 Def / 69 SpA / 94 SpD / 68 Spe",
  "moves": [
   "Earthquake",
   "Skitter Smack",
   "Poltergeist",
   "Horn Leech"
  ]
 },
 "oranguru": {
  "item": "Wise Glasses",
  "nature": "Calm",
  "ability": "Inner Focus, Telepathy or Symbiosis (random)",
  "evs": "252 SpA / 252 SpD",
  "stats": "157 HP / 64 Atk / 92 Def / 134 SpA / 169 SpD / 72 Spe",
  "moves": [
   "Psych Up",
   "Terrain Pulse",
   "Psychic",
   "Thunder"
  ]
 },
 "passimian": {
  "item": "Light Ball",
  "nature": "Jolly",
  "ability": "Receiver or Defiant (random)",
  "evs": "252 Atk / 252 Spe",
  "stats": "167 HP / 164 Atk / 102 Def / 46 SpA / 72 SpD / 136 Spe",
  "moves": [
   "Electroweb",
   "Fling",
   "Acrobatics",
   "Drain Punch"
  ]
 },
 "morpeko": {
  "item": "Liechi Berry",
  "nature": "Jolly",
  "ability": "Hunger Switch",
  "evs": "252 HP / 252 Atk",
  "stats": "157 HP / 139 Atk / 70 Def / 73 SpA / 70 SpD / 119 Spe",
  "moves": [
   "Aura Wheel",
   "Fake Out",
   "Parting Shot",
   "Bullet Seed"
  ]
 },
 "falinks": {
  "item": "Rocky Helmet",
  "nature": "Brave",
  "ability": "Battle Armor or Defiant (random)",
  "evs": "252 HP / 252 Atk",
  "stats": "164 HP / 158 Atk / 112 Def / 82 SpA / 72 SpD / 78 Spe",
  "moves": [
   "No Retreat",
   "First Impression",
   "Bulk Up",
   "Brick Break"
  ]
 },
 "lunatone": {
  "item": "Utility Umbrella",
  "nature": "Calm",
  "ability": "Levitate",
  "evs": "252 HP / 252 SpD",
  "stats": "189 HP / 60 Atk / 77 Def / 107 SpA / 141 SpD / 82 Spe",
  "moves": [
   "Moonlight",
   "Moonblast",
   "Cosmic Power",
   "Power Gem"
  ]
 },
 "solrock": {
  "item": "Hard Stone",
  "nature": "Jolly",
  "ability": "Levitate",
  "evs": "252 HP / 252 Atk",
  "stats": "189 HP / 139 Atk / 97 Def / 60 SpA / 77 SpD / 90 Spe",
  "moves": [
   "Cosmic Power",
   "Flare Blitz",
   "Rock Blast",
   "Zen Headbutt"
  ]
 },
 "grapploct": {
  "item": "Cell Battery",
  "nature": "Impish",
  "ability": "Limber or Technician (random)",
  "evs": "252 HP / 252 Atk",
  "stats": "179 HP / 162 Atk / 112 Def / 73 SpA / 92 SpD / 54 Spe",
  "moves": [
   "Taunt",
   "Stomping Tantrum",
   "Submission",
   "Circle Throw"
  ]
 },
 "pincurchin": {
  "item": "Electric Seed",
  "nature": "Modest",
  "ability": "Lightning Rod or Electric Surge (random)",
  "evs": "252 HP / 252 SpA",
  "stats": "147 HP / 101 Atk / 107 Def / 148 SpA / 97 SpD / 27 Spe",
  "moves": [
   "Rising Voltage",
   "Hex",
   "Charge",
   "Brine"
  ]
 },
 "mantine": {
  "item": "Chesto Berry",
  "nature": "Modest",
  "ability": "Swift Swim, Water Absorb or Water Veil (random)",
  "evs": "252 HP / 252 SpD",
  "stats": "184 HP / 46 Atk / 82 Def / 101 SpA / 184 SpD / 82 Spe",
  "moves": [
   "Rain Dance",
   "Hurricane",
   "Hydro Pump",
   "Rest"
  ]
 },
 "wailord": {
  "item": "Liechi Berry",
  "nature": "Impish",
  "ability": "Water Veil, Oblivious or Pressure (random)",
  "evs": "252 HP / 252 Atk",
  "stats": "269 HP / 134 Atk / 62 Def / 91 SpA / 57 SpD / 72 Spe",
  "moves": [
   "Tickle",
   "Self-Destruct",
   "Bulldoze",
   "Soak"
  ]
 },
 "drampa": {
  "item": "Adrenaline Orb",
  "nature": "Timid",
  "ability": "Berserk, Sap Sipper or Cloud Nine (random)",
  "evs": "252 Atk / 252 SpA",
  "stats": "145 HP / 93 Atk / 97 Def / 179 SpA / 103 SpD / 52 Spe",
  "moves": [
   "Scale Shot",
   "Dragon Pulse",
   "Snarl",
   "Fly"
  ]
 },
 "turtonator": {
  "item": "Absorb Bulb",
  "nature": "Modest",
  "ability": "Shell Armor",
  "evs": "252 HP / 252 SpA",
  "stats": "159 HP / 81 Atk / 147 Def / 148 SpA / 97 SpD / 48 Spe",
  "moves": [
   "Shell Trap",
   "Incinerate",
   "Dragon Pulse",
   "Burning Jealousy"
  ]
 },
 "mrrime": {
  "item": "Sitrus Berry",
  "nature": "Timid",
  "ability": "Tangled Feet, Screen Cleaner or Ice Body (random)",
  "evs": "252 HP / 252 Spe",
  "stats": "179 HP / 87 Atk / 87 Def / 122 SpA / 112 SpD / 125 Spe",
  "moves": [
   "Recycle",
   "Copycat",
   "Mirror Coat",
   "Psychic"
  ]
 },
 "rotom": {
  "item": "Shuca Berry",
  "nature": "Timid",
  "ability": "Levitate",
  "evs": "252 HP / 252 Spe",
  "stats": "149 HP / 55 Atk / 89 Def / 107 SpA / 89 SpD / 148 Spe",
  "moves": [
   "Discharge",
   "Volt Switch",
   "Light Screen",
   "Hyper Voice"
  ]
 },
 "flapple": {
  "item": "Yache Berry",
  "nature": "Jolly",
  "ability": "Ripen, Gluttony or Hustle (random)",
  "evs": "252 Atk / 252 Spe",
  "stats": "137 HP / 154 Atk / 92 Def / 96 SpA / 72 SpD / 125 Spe",
  "moves": [
   "Grassy Glide",
   "Dual Wingbeat",
   "Dragon Rush",
   "Grav Apple"
  ]
 },
 "appletun": {
  "item": "Sitrus Berry",
  "nature": "Calm",
  "ability": "Ripen, Gluttony or Thick Fat (random)",
  "evs": "252 HP / 252 SpA",
  "stats": "209 HP / 87 Atk / 92 Def / 144 SpA / 101 SpD / 42 Spe",
  "moves": [
   "Dragon Pulse",
   "Recycle",
   "Sunny Day",
   "Solar Beam"
  ]
 },
 "meowstic": {
  "item": "Throat Spray",
  "nature": "Quiet",
  "ability": "Keen Eye, Infiltrator or Prankster (random)",
  "evs": "252 SpA / 252 Spe",
  "stats": "141 HP / 60 Atk / 88 Def / 139 SpA / 93 SpD / 133 Spe",
  "moves": [
   "Rest",
   "Snore",
   "Disarming Voice",
   "Yawn"
  ]
 },
 "goodra": {
  "item": "Lansat Berry",
  "nature": "Hardy",
  "ability": "Sap Sipper, Hydration or Gooey (random)",
  "evs": "252 HP / 252 Spe",
  "stats": "189 HP / 112 Atk / 82 Def / 122 SpA / 162 SpD / 124 Spe",
  "moves": [
   "Draco Meteor",
   "Breaking Swipe",
   "Focus Blast",
   "Bulldoze"
  ]
 },
 "kommoo": {
  "item": "Muscle Band",
  "nature": "Hardy",
  "ability": "Bulletproof, Soundproof or Overcoat (random)",
  "evs": "252 Atk / 252 SpA",
  "stats": "142 HP / 154 Atk / 137 Def / 144 SpA / 117 SpD / 97 Spe",
  "moves": [
   "Clangorous Soul",
   "Scale Shot",
   "Draco Meteor",
   "Close Combat"
  ]
 },
 "pikachu": {
  "item": "Light Ball",
  "nature": "Hardy",
  "ability": "Static or Lightning Rod (random)",
  "evs": "252 Atk / 252 Spe",
  "stats": "102 HP / 99 Atk / 52 Def / 62 SpA / 62 SpD / 134 Spe",
  "moves": [
   "Thunderbolt",
   "Volt Tackle",
   "Play Rough",
   "Quick Attack"
  ]
 },
 "sandslash": {
  "item": "Scope Lens",
  "nature": "Jolly",
  "ability": "Sand Veil or Sand Rush (random)",
  "evs": "252 Atk / 252 Spe",
  "stats": "142 HP / 144 Atk / 122 Def / 51 SpA / 67 SpD / 119 Spe",
  "moves": [
   "Crush Claw",
   "Dig",
   "Sandstorm",
   "Rock Tomb"
  ]
 },
 "golduck": {
  "item": "Mystic Water",
  "nature": "Mild",
  "ability": "Damp, Cloud Nine or Swift Swim (random)",
  "evs": "252 HP / 252 SpA",
  "stats": "179 HP / 94 Atk / 81 Def / 152 SpA / 92 SpD / 97 Spe",
  "moves": [
   "Aqua Jet",
   "Amnesia",
   "Ice Beam",
   "Surf"
  ]
 },
 "poliwrath": {
  "item": "Zoom Lens",
  "nature": "Brave",
  "ability": "Water Absorb, Damp or Swift Swim (random)",
  "evs": "252 HP / 252 Atk",
  "stats": "189 HP / 152 Atk / 107 Def / 82 SpA / 102 SpD / 73 Spe",
  "moves": [
   "Circle Throw",
   "Dynamic Punch",
   "Payback",
   "Liquidation"
  ]
 },
 "alakazam": {
  "item": "Absorb Bulb",
  "nature": "Timid",
  "ability": "Synchronize, Inner Focus or Magic Guard (random)",
  "evs": "252 SpA / 252 Spe",
  "stats": "122 HP / 55 Atk / 57 Def / 179 SpA / 107 SpD / 180 Spe",
  "moves": [
   "Safeguard",
   "Light Screen",
   "Shadow Ball",
   "Psychic"
  ]
 },
 "tentacruel": {
  "item": "Black Sludge",
  "nature": "Careful",
  "ability": "Clear Body, Liquid Ooze or Rain Dish (random)",
  "evs": "252 HP / 252 SpD",
  "stats": "179 HP / 82 Atk / 77 Def / 82 SpA / 180 SpD / 112 Spe",
  "moves": [
   "Swords Dance",
   "Cross Poison",
   "Icy Wind",
   "Waterfall"
  ]
 },
 "magneton": {
  "item": "Eviolite",
  "nature": "Timid",
  "ability": "Magnet Pull, Sturdy or Analytic (random)",
  "evs": "252 HP / 252 SpA",
  "stats": "149 HP / 64 Atk / 107 Def / 164 SpA / 82 SpD / 90 Spe",
  "moves": [
   "Flash Cannon",
   "Electro Ball",
   "Thunder Wave",
   "Magnet Rise"
  ]
 },
 "exeggutor": {
  "item": "Power Herb",
  "nature": "Modest",
  "ability": "Chlorophyll or Harvest (random)",
  "evs": "252 HP / 252 SpA",
  "stats": "194 HP / 96 Atk / 97 Def / 185 SpA / 87 SpD / 67 Spe",
  "moves": [
   "Solar Beam",
   "Psychic",
   "Future Sight",
   "Trick Room"
  ]
 },
 "marowak": {
  "item": "Thick Club",
  "nature": "Lonely",
  "ability": "Rock Head, Lightning Rod or Battle Armor (random)",
  "evs": "252 HP / 252 Atk",
  "stats": "159 HP / 136 Atk / 109 Def / 62 SpA / 92 SpD / 57 Spe",
  "moves": [
   "Throat Chop",
   "Iron Head",
   "Bonemerang",
   "Outrage"
  ]
 },
 "kangaskhan": {
  "item": "Protective Pads",
  "nature": "Brave",
  "ability": "Early Bird, Scrappy or Inner Focus (random)",
  "evs": "252 HP / 252 Atk",
  "stats": "204 HP / 152 Atk / 92 Def / 52 SpA / 92 SpD / 91 Spe",
  "moves": [
   "Retaliate",
   "Sucker Punch",
   "Drain Punch",
   "Rock Slide"
  ]
 },
 "starmie": {
  "item": "Life Orb",
  "nature": "Timid",
  "ability": "Illuminate, Natural Cure or Analytic (random)",
  "evs": "252 SpA / 252 Spe",
  "stats": "127 HP / 78 Atk / 97 Def / 144 SpA / 97 SpD / 174 Spe",
  "moves": [
   "Thunderbolt",
   "Ice Beam",
   "Psychic",
   "Surf"
  ]
 },
 "pinsir": {
  "item": "Eject Pack",
  "nature": "Adamant",
  "ability": "Hyper Cutter, Mold Breaker or Moxie (random)",
  "evs": "252 Atk / 252 Spe",
  "stats": "132 HP / 185 Atk / 112 Def / 60 SpA / 82 SpD / 129 Spe",
  "moves": [
   "Stealth Rock",
   "Close Combat",
   "Bug Bite",
   "Seismic Toss"
  ]
 },
 "tauros": {
  "item": "Toxic Orb",
  "nature": "Jolly",
  "ability": "Intimidate, Anger Point or Sheer Force (random)",
  "evs": "252 Atk / 252 Spe",
  "stats": "142 HP / 144 Atk / 107 Def / 46 SpA / 82 SpD / 169 Spe",
  "moves": [
   "Facade",
   "Lash Out",
   "Stomping Tantrum",
   "Rock Tomb"
  ]
 },
 "azumarill": {
  "item": "Mystic Water",
  "nature": "Adamant",
  "ability": "Thick Fat, Huge Power or Sap Sipper (random)",
  "evs": "252 HP / 252 Atk",
  "stats": "199 HP / 103 Atk / 92 Def / 64 SpA / 92 SpD / 62 Spe",
  "moves": [
   "Aqua Jet",
   "Belly Drum",
   "Steel Roller",
   "Body Slam"
  ]
 },
 "politoed": {
  "item": "Damp Rock",
  "nature": "Calm",
  "ability": "Water Absorb, Damp or Drizzle (random)",
  "evs": "252 SpA / 252 SpD",
  "stats": "157 HP / 78 Atk / 87 Def / 134 SpA / 158 SpD / 82 Spe",
  "moves": [
   "Encore",
   "Perish Song",
   "Hydro Pump",
   "Focus Blast"
  ]
 },
 "dunsparce": {
  "item": "Eject Pack",
  "nature": "Relaxed",
  "ability": "Serene Grace, Run Away or Rattled (random)",
  "evs": "252 HP / 252 SpD",
  "stats": "199 HP / 82 Atk / 90 Def / 77 SpA / 109 SpD / 51 Spe",
  "moves": [
   "Skitter Smack",
   "Ancient Power",
   "Dragon Rush",
   "Dual Wingbeat"
  ]
 },
 "scizor": {
  "item": "Expert Belt",
  "nature": "Adamant",
  "ability": "Swarm, Technician or Light Metal (random)",
  "evs": "252 HP / 252 Atk",
  "stats": "169 HP / 191 Atk / 112 Def / 60 SpA / 92 SpD / 77 Spe",
  "moves": [
   "Dual Wingbeat",
   "Swords Dance",
   "Bullet Punch",
   "X-Scissor"
  ]
 },
 "heracross": {
  "item": "Blunder Policy",
  "nature": "Jolly",
  "ability": "Swarm, Guts or Moxie (random)",
  "evs": "252 Atk / 252 Spe",
  "stats": "147 HP / 169 Atk / 87 Def / 46 SpA / 107 SpD / 141 Spe",
  "moves": [
   "Megahorn",
   "Stone Edge",
   "Bulk Up",
   "Throat Chop"
  ]
 },
 "skarmory": {
  "item": "Maranga Berry",
  "nature": "Impish",
  "ability": "Keen Eye, Sturdy or Weak Armor (random)",
  "evs": "252 Atk / 252 Def",
  "stats": "132 HP / 124 Atk / 202 Def / 46 SpA / 82 SpD / 82 Spe",
  "moves": [
   "Dual Wingbeat",
   "Spikes",
   "Body Press",
   "Steel Wing"
  ]
 },
 "kingdra": {
  "item": "Scope Lens",
  "nature": "Timid",
  "ability": "Swift Swim, Sniper or Damp (random)",
  "evs": "252 SpA / 252 Spe",
  "stats": "142 HP / 96 Atk / 107 Def / 139 SpA / 107 SpD / 141 Spe",
  "moves": [
   "Draco Meteor",
   "Dragon Pulse",
   "Hydro Pump",
   "Blizzard"
  ]
 },
 "porygon2": {
  "item": "Eviolite",
  "nature": "Bold",
  "ability": "Trace, Download or Analytic (random)",
  "evs": "252 HP / 252 Def",
  "stats": "184 HP / 82 Atk / 147 Def / 117 SpA / 107 SpD / 72 Spe",
  "moves": [
   "Conversion 2",
   "Trick Room",
   "Tri Attack",
   "Psychic"
  ]
 },
 "miltank": {
  "item": "Binding Band",
  "nature": "Bold",
  "ability": "Thick Fat, Scrappy or Sap Sipper (random)",
  "evs": "252 HP / 252 Def",
  "stats": "194 HP / 82 Atk / 163 Def / 52 SpA / 82 SpD / 112 Spe",
  "moves": [
   "Whirlpool",
   "Milk Drink",
   "Thunderbolt",
   "Endure"
  ]
 },
 "blissey": {
  "item": "Mental Herb",
  "nature": "Gentle",
  "ability": "Natural Cure, Serene Grace or Healer (random)",
  "evs": "252 SpA / 252 SpD",
  "stats": "322 HP / 22 Atk / 19 Def / 119 SpA / 196 SpD / 67 Spe",
  "moves": [
   "Metronome",
   "Safeguard",
   "Grass Knot",
   "Flamethrower"
  ]
 },
 "exploud": {
  "item": "Throat Spray",
  "nature": "Modest",
  "ability": "Soundproof or Scrappy (random)",
  "evs": "252 HP / 252 SpA",
  "stats": "203 HP / 92 Atk / 75 Def / 148 SpA / 85 SpD / 80 Spe",
  "moves": [
   "Boomburst",
   "Focus Blast",
   "Terrain Pulse",
   "Surf"
  ]
 },
 "sharpedo": {
  "item": "Adrenaline Orb",
  "nature": "Adamant",
  "ability": "Rough Skin or Speed Boost (random)",
  "evs": "252 Atk / 252 Spe",
  "stats": "137 HP / 180 Atk / 52 Def / 96 SpA / 52 SpD / 139 Spe",
  "moves": [
   "Protect",
   "Crunch",
   "Liquidation",
   "Poison Jab"
  ]
 },
 "luxray": {
  "item": "Magnet",
  "nature": "Adamant",
  "ability": "Rivalry, Intimidate or Guts (random)",
  "evs": "252 Atk / 252 Spe",
  "stats": "147 HP / 180 Atk / 91 Def / 96 SpA / 91 SpD / 114 Spe",
  "moves": [
   "Wild Charge",
   "Psychic Fangs",
   "Play Rough",
   "Eerie Impulse"
  ]
 },
 "lopunny": {
  "item": "Salac Berry",
  "nature": "Jolly",
  "ability": "Cute Charm, Klutz or Limber (random)",
  "evs": "252 Atk / 252 Spe",
  "stats": "132 HP / 120 Atk / 96 Def / 59 SpA / 108 SpD / 163 Spe",
  "moves": [
   "Play Rough",
   "Triple Axel",
   "Cosmic Power",
   "Baton Pass"
  ]
 },
 "magnezone": {
  "item": "Air Balloon",
  "nature": "Quiet",
  "ability": "Magnet Pull, Sturdy or Analytic (random)",
  "evs": "252 Def / 252 SpA",
  "stats": "137 HP / 82 Atk / 159 Def / 191 SpA / 102 SpD / 64 Spe",
  "moves": [
   "Steel Beam",
   "Thunderbolt",
   "Light Screen",
   "Reflect"
  ]
 },
 "lickilicky": {
  "item": "Metronome",
  "nature": "Brave",
  "ability": "Own Tempo, Oblivious or Cloud Nine (random)",
  "evs": "252 HP / 252 Atk",
  "stats": "209 HP / 141 Atk / 107 Def / 92 SpA / 107 SpD / 55 Spe",
  "moves": [
   "Defense Curl",
   "Rollout",
   "Disable",
   "Body Slam"
  ]
 },
 "tangrowth": {
  "item": "Grassy Seed",
  "nature": "Brave",
  "ability": "Chlorophyll, Leaf Guard or Regenerator (random)",
  "evs": "252 HP / 252 Atk",
  "stats": "199 HP / 158 Atk / 137 Def / 122 SpA / 62 SpD / 55 Spe",
  "moves": [
   "Grassy Terrain",
   "Grassy Glide",
   "Payback",
   "Ancient Power"
  ]
 },
 "porygonz": {
  "item": "Normal Gem",
  "nature": "Hardy",
  "ability": "Adaptability, Download or Analytic (random)",
  "evs": "252 SpA / 252 Spe",
  "stats": "152 HP / 92 Atk / 82 Def / 179 SpA / 87 SpD / 134 Spe",
  "moves": [
   "Shadow Ball",
   "Tri Attack",
   "Conversion",
   "Recycle"
  ]
 },
 "stoutland": {
  "item": "Silk Scarf",
  "nature": "Hardy",
  "ability": "Intimidate, Sand Rush or Scrappy (random)",
  "evs": "252 HP / 252 Spe",
  "stats": "184 HP / 122 Atk / 102 Def / 57 SpA / 102 SpD / 124 Spe",
  "moves": [
   "Work Up",
   "Play Rough",
   "Thunderbolt",
   "Hyper Beam"
  ]
 },
 "scolipede": {
  "item": "Liechi Berry",
  "nature": "Adamant",
  "ability": "Poison Point, Swarm or Speed Boost (random)",
  "evs": "252 HP / 252 Atk",
  "stats": "159 HP / 158 Atk / 101 Def / 60 SpA / 81 SpD / 124 Spe",
  "moves": [
   "Skitter Smack",
   "Steel Roller",
   "Baton Pass",
   "Iron Defense"
  ]
 },
 "lilligant": {
  "item": "Big Root",
  "nature": "Modest",
  "ability": "Chlorophyll, Own Tempo or Leaf Guard (random)",
  "evs": "252 SpA / 252 Spe",
  "stats": "137 HP / 64 Atk / 87 Def / 169 SpA / 87 SpD / 134 Spe",
  "moves": [
   "Quiver Dance",
   "Pollen Puff",
   "Giga Drain",
   "Charm"
  ]
 },
 "krookodile": {
  "item": "Weakness Policy",
  "nature": "Adamant",
  "ability": "Intimidate, Moxie or Anger Point (random)",
  "evs": "252 HP / 252 Atk",
  "stats": "194 HP / 177 Atk / 92 Def / 69 SpA / 82 SpD / 104 Spe",
  "moves": [
   "Power Trip",
   "Bulk Up",
   "Sand Tomb",
   "Thief"
  ]
 },
 "zoroark": {
  "item": "Eject Button",
  "nature": "Rash",
  "ability": "Illusion",
  "evs": "252 SpA / 252 Spe",
  "stats": "127 HP / 117 Atk / 72 Def / 180 SpA / 64 SpD / 149 Spe",
  "moves": [
   "Flamethrower",
   "Foul Play",
   "Night Daze",
   "U-turn"
  ]
 },
 "emolga": {
  "item": "Apicot Berry",
  "nature": "Timid",
  "ability": "Static or Motor Drive (random)",
  "evs": "252 HP / 252 Spe",
  "stats": "154 HP / 78 Atk / 72 Def / 87 SpA / 72 SpD / 161 Spe",
  "moves": [
   "Electro Ball",
   "Baton Pass",
   "Agility",
   "Acrobatics"
  ]
 },
 "amoonguss": {
  "item": "Miracle Seed",
  "nature": "Bold",
  "ability": "Effect Spore or Regenerator (random)",
  "evs": "252 HP / 252 Def",
  "stats": "213 HP / 87 Atk / 125 Def / 97 SpA / 92 SpD / 42 Spe",
  "moves": [
   "Giga Drain",
   "Clear Smog",
   "Ingrain",
   "Spore"
  ]
 },
 "mienshao": {
  "item": "Lum Berry",
  "nature": "Hasty",
  "ability": "Inner Focus, Regenerator or Reckless (random)",
  "evs": "252 Atk / 252 Spe",
  "stats": "132 HP / 169 Atk / 64 Def / 107 SpA / 72 SpD / 163 Spe",
  "moves": [
   "High Jump Kick",
   "Blaze Kick",
   "Aura Sphere",
   "Fake Out"
  ]
 },
 "druddigon": {
  "item": "Rocky Helmet",
  "nature": "Adamant",
  "ability": "Rough Skin, Sheer Force or Mold Breaker (random)",
  "evs": "252 HP / 252 Atk",
  "stats": "176 HP / 180 Atk / 102 Def / 64 SpA / 102 SpD / 60 Spe",
  "moves": [
   "Dragon Tail",
   "Poison Tail",
   "Endure",
   "Taunt"
  ]
 },
 "bouffalant": {
  "item": "Kee Berry",
  "nature": "Jolly",
  "ability": "Reckless, Sap Sipper or Soundproof (random)",
  "evs": "252 HP / 252 Spe",
  "stats": "194 HP / 122 Atk / 107 Def / 46 SpA / 107 SpD / 108 Spe",
  "moves": [
   "Head Charge",
   "Revenge",
   "Earthquake",
   "Giga Impact"
  ]
 },
 "volcarona": {
  "item": "Heavy-Duty Boots",
  "nature": "Modest",
  "ability": "Flame Body or Swarm (random)",
  "evs": "252 SpA / 252 Spe",
  "stats": "152 HP / 64 Atk / 77 Def / 196 SpA / 117 SpD / 144 Spe",
  "moves": [
   "Flame Charge",
   "Heat Wave",
   "Struggle Bug",
   "Bug Buzz"
  ]
 },
 "talonflame": {
  "item": "Sticky Barb",
  "nature": "Brave",
  "ability": "Flame Body or Gale Wings (random)",
  "evs": "252 HP / 252 Def",
  "stats": "177 HP / 102 Atk / 115 Def / 86 SpA / 81 SpD / 124 Spe",
  "moves": [
   "Fly",
   "Roost",
   "U-turn",
   "Overheat"
  ]
 },
 "dragalge": {
  "item": "White Herb",
  "nature": "Timid",
  "ability": "Poison Point, Poison Touch or Adaptability (random)",
  "evs": "252 SpA / 252 Spe",
  "stats": "132 HP / 78 Atk / 102 Def / 141 SpA / 135 SpD / 96 Spe",
  "moves": [
   "Toxic Spikes",
   "Draco Meteor",
   "Flip Turn",
   "Venoshock"
  ]
 },
 "clawitzer": {
  "item": "Misty Seed",
  "nature": "Modest",
  "ability": "Mega Launcher",
  "evs": "252 SpA / 252 Spe",
  "stats": "138 HP / 76 Atk / 100 Def / 180 SpA / 101 SpD / 103 Spe",
  "moves": [
   "Terrain Pulse",
   "Dragon Pulse",
   "Water Pulse",
   "Aqua Jet"
  ]
 },
 "dedenne": {
  "item": "Air Balloon",
  "nature": "Timid",
  "ability": "Cheek Pouch, Pickup or Plus (random)",
  "evs": "252 HP / 252 Spe",
  "stats": "166 HP / 63 Atk / 69 Def / 93 SpA / 79 SpD / 159 Spe",
  "moves": [
   "Parabolic Charge",
   "Dazzling Gleam",
   "Charm",
   "Super Fang"
  ]
 },
 "klefki": {
  "item": "Mental Herb",
  "nature": "Calm",
  "ability": "Prankster or Magician (random)",
  "evs": "252 HP / 252 Spe",
  "stats": "156 HP / 82 Atk / 103 Def / 92 SpA / 108 SpD / 119 Spe",
  "moves": [
   "Metal Sound",
   "Torment",
   "Steel Beam",
   "Foul Play"
  ]
 },
 "lycanroc": {
  "item": "Hard Stone",
  "nature": "Adamant",
  "ability": "Keen Eye, Sand Rush or Steadfast (random)",
  "evs": "252 HP / 252 Atk",
  "stats": "174 HP / 174 Atk / 77 Def / 60 SpA / 77 SpD / 124 Spe",
  "moves": [
   "Accelerock",
   "Stealth Rock",
   "Roar",
   "Psychic Fangs"
  ]
 },
 "lycanrocmidnight": {
  "item": "Salac Berry",
  "nature": "Adamant",
  "ability": "Keen Eye, Vital Spirit or No Guard (random)",
  "evs": "252 HP / 252 Atk",
  "stats": "184 HP / 174 Atk / 87 Def / 60 SpA / 87 SpD / 94 Spe",
  "moves": [
   "Endure",
   "Reversal",
   "Rock Slide",
   "Fire Punch"
  ]
 },
 "lurantis": {
  "item": "Heat Rock",
  "nature": "Lonely",
  "ability": "Leaf Guard or Contrary (random)",
  "evs": "252 HP / 252 Atk",
  "stats": "169 HP / 163 Atk / 91 Def / 92 SpA / 102 SpD / 57 Spe",
  "moves": [
   "Solar Blade",
   "Night Slash",
   "Leaf Storm",
   "Sunny Day"
  ]
 },
 "comfey": {
  "item": "Big Root",
  "nature": "Modest",
  "ability": "Flower Veil, Triage or Natural Cure (random)",
  "evs": "252 HP / 252 Spe",
  "stats": "150 HP / 57 Atk / 102 Def / 103 SpA / 122 SpD / 144 Spe",
  "moves": [
   "Draining Kiss",
   "Giga Drain",
   "Leech Seed",
   "Grassy Terrain"
  ]
 },
 "palossand": {
  "item": "Passho Berry",
  "nature": "Quiet",
  "ability": "Water Compaction or Sand Veil (random)",
  "evs": "252 HP / 252 SpA",
  "stats": "184 HP / 87 Atk / 122 Def / 158 SpA / 87 SpD / 42 Spe",
  "moves": [
   "Poltergeist",
   "Scorching Sands",
   "Shore Up",
   "Energy Ball"
  ]
 }
};
